import * as React from 'react'
import Dialog from '@mui/material/Dialog'
import Slide from '@mui/material/Slide'
import {TransitionProps} from '@mui/material/transitions'
import {styled} from '@mui/material'

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction='up' ref={ref} {...props} />
})

const Title = styled('h4')(() => ({
  margin: 0,
  marginBottom: '8px',
  textTransform: 'capitalize',
}))

const DialogBox = styled('div')(() => ({
  width: 360,
  padding: '32px',
  textAlign: 'center',
  marginLeft: 'auto',
  marginRight: 'auto',
}))

const Controller = styled('div')(() => ({
  margin: '8px',
  paddingTop: '8px',
  display: 'flex',
  justifyContent: 'center',
}))

interface ConfirmationModal {
  open: boolean
  text: string
  onYesClick: React.MouseEventHandler<HTMLButtonElement> | undefined
  onConfirmDialogClose: React.MouseEventHandler<HTMLButtonElement> | undefined
}

const ConfirmationDialog = ({open, text, onYesClick, onConfirmDialogClose}: ConfirmationModal) => {
  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={onConfirmDialogClose}
      >
        <DialogBox>
          <i className='text-warning fs-2tx bi bi-exclamation-circle'></i>
          <Title className="mt-5">CONFIRM</Title>
          <p>{text}</p>
          <Controller>
            <button className='btn btn-primary btn-sm' onClick={onYesClick}>
              Yes
            </button>
            <span className='m-1'></span>
            <button className='btn btn-secondary btn-sm' onClick={onConfirmDialogClose}>
              No
            </button>
          </Controller>
        </DialogBox>
      </Dialog>
    </div>
  )
}

export default ConfirmationDialog
